import localeConfig from '../i18n/config'

export function getLocaleList () {
  return Object.keys(localeConfig.messages)
}
